<template>
<ul>
  <li v-for="(node, index) in nodes" :key="index" class="navbar-item" :class="node.class">
    <click-dropdown :toggleArrow="toggleArrow" :node="node">
      <slot></slot>
    </click-dropdown>
  </li>
</ul>
</template>

<script>
import ClickDropdown from '@components/ClickDropdown.vue'
export default {
  components: {
    ClickDropdown
  },
  props: {
    toggleArrow: Boolean,
    nodes: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style scoped lang="scss">
  ::v-deep {
    li:last-child:not(:first-child) .subnav {
      right: 0;
    }
  }
</style>
